'use client'

import appStoreLogoEn from '@public/images/app_store.svg'
import appStoreLogoFr from '@public/images/app_store_fr.svg'
import googlePlayLogoEn from '@public/images/google_play.svg'
import googlePlayLogoFr from '@public/images/google_play_fr.svg'
import Image from 'next/image'
import Link from 'next/link'

import { LocaleSwitcher } from '@src/components/LocaleSwitcher/LocaleSwitcher'
import type { TopNavV6Props } from '@src/components/TopNavV6/TopNavV6Props'
import { configPublic } from '@src/config.public'
import { useLocale } from '@src/i18n/LocaleProvider'
import { useTrackSelectCta } from '@src/utils/analytics.util'

import facebookImg from '../../BigFooter/assets/facebook.svg'
import instagramImg from '../../BigFooter/assets/instagram.svg'
import youtubeImg from '../../BigFooter/assets/youtube.svg'

export const TopNavV6MobileFooter = (props: TopNavV6Props) => {
  const { locale } = useLocale()
  const trackSelectCta = useTrackSelectCta()
  const appStoreLogo: Record<string, any> = { en: appStoreLogoEn, fr: appStoreLogoFr }
  const googlePlayLogo: Record<string, any> = { en: googlePlayLogoEn, fr: googlePlayLogoFr }

  const appStoreUrl =
    configPublic.general.bodIosAppUrl ??
    'https://apps.apple.com/us/app/bodi-by-beachbody-home-fitness/id1031660123'
  const googlePlayUrl =
    configPublic.general.bodAndroidAppUrl ??
    'https://play.google.com/store/apps/details?id=com.beachbody.bod'
  const {
    instagramUrl = 'https://instagram.com/bodi',
    facebookUrl = 'https://facebook.com/bodi',
    youtubeUrl = 'https://youtube.com/@bodi',
  } = props

  return (
    <div className="flex flex-col gap-8 px-4 pb-8">
      {/* App badges */}
      <div className="mx-auto flex gap-6">
        <Link href={appStoreUrl} className="shrink-0">
          <Image
            className="h-10"
            src={appStoreLogo[locale.lang]}
            width={120}
            height={40}
            alt="App Store"
            onClick={() => {
              trackSelectCta({ 'cta url': appStoreUrl })
            }}
          />
        </Link>
        <Link href={googlePlayUrl} className="shrink-0">
          <Image
            className="h-10"
            src={googlePlayLogo[locale.lang]}
            width={135}
            height={40}
            alt="Google Play"
            onClick={() => {
              trackSelectCta({ 'cta url': googlePlayUrl })
            }}
          />
        </Link>
      </div>

      {/* Social icons */}
      <div className="mx-auto flex gap-6">
        <Link
          href={instagramUrl}
          onClick={() => {
            trackSelectCta({ 'cta url': instagramUrl })
          }}
        >
          <Image src={instagramImg} width={36} height={36} alt="Instagram" className="invert" />
        </Link>
        <Link
          href={facebookUrl}
          onClick={() => {
            trackSelectCta({ 'cta url': facebookUrl })
          }}
        >
          <Image src={facebookImg} width={36} height={36} alt="Facebook" className="invert" />
        </Link>
        <Link
          href={youtubeUrl}
          onClick={() => {
            trackSelectCta({ 'cta url': youtubeUrl })
          }}
        >
          <Image src={youtubeImg} width={36} height={36} alt="YouTube" className="invert" />
        </Link>
      </div>

      <div className="mx-auto">
        <LocaleSwitcher />
      </div>
    </div>
  )
}
